/**
 * Configuration section submenu — single source of truth for routes/labels
 * (used by Sidebar and pages like Document Categories for header tabs).
 */
export interface ConfigurationNavItem {
  page: string;
  labelKey: string;
  href: string;
}

export const CONFIGURATION_SECTION_NAV: ConfigurationNavItem[] = [
  { page: 'configuration-dashboard', labelKey: 'Sidebar.Dashboard', href: '/configuration/dashboard' },
  { page: 'document-categories', labelKey: 'Sidebar.DocumentCategories', href: '/document-categories' },
  { page: 'services-status', labelKey: 'Sidebar.ServicesStatus', href: '/configuration/services-status' },
  { page: 'Activities', labelKey: 'Sidebar.Activities', href: '/activities' },
  { page: 'ControlReferencePage', labelKey: 'Sidebar.ControlReference', href: '/controlReference' },
  { page: 'FinancialImpactsPage', labelKey: 'Sidebar.Financial Impacts', href: '/financialImpacts' },
  { page: 'EventTypePage', labelKey: 'Sidebar.EventType', href: '/eventType' },
  { page: 'AccountTypePage', labelKey: 'Sidebar.AccountType', href: '/accountType' },
  { page: 'process', labelKey: 'Sidebar.Process', href: '/process' },
  { page: 'CreateSubBusinessUnitPage', labelKey: 'Sidebar.SubBusinessUnit', href: '/subBusinessUnit' },
  { page: 'CreateSystem', labelKey: 'Sidebar.System', href: '/system' },
  { page: 'CreateJobTitle', labelKey: 'Sidebar.JobTitle', href: '/jobTitle' },
  { page: 'CreateDiscoveredType', labelKey: 'Sidebar.DiscoveredType', href: '/discoveredTypes' },
  { page: 'CreateCurrencyPage', labelKey: 'Sidebar.Currency', href: '/createCurrency' },
  { page: 'CreateRootCause', labelKey: 'Sidebar.RootCause', href: '/rootCause' },
  { page: 'CreateSubFunction', labelKey: 'Sidebar.SubFunction', href: '/subFunction' },
  { page: 'CreateRiskCategory', labelKey: 'Sidebar.RiskCategory', href: '/riskCategory' },
  { page: 'collection-sops', labelKey: 'Sidebar.CollectionSops', href: '/catalogs/collection-sops' },
  { page: 'sop-masters', labelKey: 'Sidebar.SopMasters', href: '/catalogs/sop-masters' },
  { page: 'lifecycle-stages', labelKey: 'Sidebar.LifecycleStages', href: '/configuration/lifecycle-stages' },
  { page: 'criticalities', labelKey: 'Sidebar.Criticalities', href: '/configuration/criticalities' },
  { page: 'asset-types', labelKey: 'Sidebar.AssetTypes', href: '/configuration/asset-types' },
  { page: 'asset-classifications', labelKey: 'Sidebar.AssetClassifications', href: '/configuration/asset-classifications' },
  { page: 'function', labelKey: 'Sidebar.RolesAndFunctions', href: '/function' },
  { page: 'policy-categories', labelKey: 'Sidebar.PolicyCategories', href: '/policy/categories' },
  { page: 'policy-settings', labelKey: 'Sidebar.Settings', href: '/policy/settings' },
  { page: 'llm-routing', labelKey: 'Sidebar.LlmRouting', href: '/llm-routing' },
];

/** Policy subsection (categories + integration settings) — same tab styling as configuration */
export const POLICY_SECTION_NAV: ConfigurationNavItem[] = [
  { page: 'policy-categories', labelKey: 'Sidebar.PolicyCategories', href: '/policy/categories' },
  { page: 'policy-settings', labelKey: 'Sidebar.Settings', href: '/policy/settings' },
];

/** Same logic as Sidebar child links: exact match or path under href */
export function isConfigurationNavItemActive(pathname: string, href: string): boolean {
  if (pathname === href) return true;
  if (href === '/' || href === '#') return false;
  return pathname.startsWith(`${href}/`);
}
